module.exports = __webpack_public_path__ + "img/conny-f-stage4-hungry.c5d8ae73.png";